/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeTriangleADownIcon32Regular = forwardRef('ArrowShapeTriangleADownIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M25.3 7c2.173 0 3.488 2.404 2.314 4.234l-9.299 14.507c-1.082 1.688-3.548 1.688-4.63 0l-9.3-14.507C3.212 9.404 4.526 7 6.7 7h18.6Zm.63 3.155A.75.75 0 0 0 25.3 9H6.7a.75.75 0 0 0-.631 1.155l9.3 14.507a.75.75 0 0 0 1.262 0l9.3-14.507Z" })));
});
